<script>
    import { assets } from "../../routes/asset/assets.state.svelte.js";
    import Spinner from "../spinner.svelte";
    let { value, rowIndex, rowId, instructKey } = $props();

    let triggerAnimation = $state(false);

    const updateEachBlock = (value) => {
        if (!value) return;
        let content = [];
        if (value[instructKey].length) {
            for (let val of value[instructKey]) {
                if (val) content.push(val);
            }
        }
        return content[0] ? Object.keys(content[0].vals) : "";
    };

    let data = $derived(updateEachBlock(value));
    let rowIdx = $derived(rowIndex);
    let key = $derived(instructKey);
</script>

{#if data && data.length > 0 && data.length == 1}
    {#each data as item, idx}
        <div>
            <a
                href={`/property/asset/port_status/${encodeURIComponent(item)}/values?value=open`}
                >{item}</a
            >
        </div>
    {/each}
{:else if data && data.length > 1}
    <div class="">
        <a
            href={`/property/asset/port_status/${encodeURIComponent(data[0])}/values?value=open`}
            >{data[0]}</a
        >
    </div>

    <!-- Let Svelte control the 'show' class based on triggerAnimation -->
    <div class="collapse" class:show={triggerAnimation}>
        {#each data as item, index}
            {#if index > 0}
                <div class="">
                    <a
                        href={`/property/asset/port_status/${encodeURIComponent(item)}/values?value=open`}
                        >{item}</a
                    >
                </div>
            {/if}
        {/each}
    </div>

    <div
        style="width: 24px; cursor: pointer;"
        onclick={(e) => {if(e) e.stopPropagation(); return (triggerAnimation = !triggerAnimation)}}
    >
        <i
            class="fas fa-chevron-down chevron-button"
            class:chevron-animation={triggerAnimation}
        ></i>
    </div>
{:else}
    <div class="loader">
        {#if assets.list.loading}
            <i class="fas fa-sync-alt fa-spin"></i>
        {/if}
    </div>
{/if}

<style>
    .loader {
        text-align: center;
    }
    .loader i {
        margin-left: -3rem;
    }
</style>
